<template>
    <div :style="{
                        backgroundImage: 'url(fr/images/summary/summary-logo.png)'
                     }"
    v-show="$route.fullPath === '/'"
    class="absolute block md:hidden w-20 h-10 top-0 right-4">
    </div>
</template>

<script>
export default {
    name: "IconEdfMobile"
}
</script>

<style scoped lang="scss">

</style>
